import { services } from '../services';
var action = "report/";

export const propertyService = {
    getProperSummaryByGroup,
    getPropertyDetail,
    getPropertyChangePrice
};



function getProperSummaryByGroup(param = '', uri='property-summary-group') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getPropertyDetail(param = '', uri='property-detail') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}
function getPropertyChangePrice(param = '', uri='property-chagne-price') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

